<template>
  <div>
    <div v-if="loading">
      <Loader :loading="loading" />
    </div>
    <div v-else>
      <AdvancedProduct v-if="isAdvanced" />
      <MiniProduct v-else />
    </div>
  </div>
</template>


<script>
import MiniProduct from './AddProduct.vue'
import AdvancedProduct from './ProductAdvanced.vue'
import IdpDataProvider from '../../services/idp'
import Loader from '../../components/widgets/loader.vue'
export default {
  components: {
    AdvancedProduct,
    MiniProduct,
    Loader,
  },
  data() {
    return {
      isAdvanced: null,
      loading: true,
    }
  },
  created() {
    IdpDataProvider.getPagePermisions({ path: '/list/product/add' }).then(res => {
      this.isAdvanced = res.data.data.permission.isAdvance
      this.loading = false
    })
  },
}
</script>
